type Item = {
  id: string;
  name?: string;
  nickname?: string;
  nickName?: string;
  shortname?: string;
  isTest?: boolean;
};

export const commonfilterCollection = (item: Item) => {
  return (
    !!(item.name || item.nickName || item.nickname || item.shortname) && !item.isTest // TODO its test assets for test scenarios
  );
};

export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;
